import React from "react";
import { useLocation, Link } from "react-router-dom";

const imageBaseURL = "";

const AnotherBlogDetails = () => {
    const location = useLocation();

    const data = location.state;

    // console.log(data);

    const sections = {
        headingListImage: data?.data?.headingListImage,
        headingMultiHeadingList: data?.data?.headingMultiHeadingList,
        headingMultiParaImage: data?.data?.headingMultiParaImage,
        headingParaImage: data?.data?.headingParaImage,
        headingParaList: data?.data?.headingParaList,
        headingWithList: data?.data?.headingWithList,
        headingWithMultiPara: data?.data?.headingWithMultiPara,
        headingWithPara: data?.data?.headingWithPara,
    };

    const mergedSections = Object.entries(sections)
        .filter(([_, value]) => Array.isArray(value) && value.length > 0)
        .flatMap(([key, value]) =>
            value.map((item) => ({
                ...item,
                sectionType: key,
            }))
        )
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    // console.log("sorted", mergedSections);

    const handleGoBack = () => {
        window.history.back();
    };
    return (
        <div className="relative  pt-[140px]">
            <div className="flex justify-between xl:px-[120px] px-3 my-4">
                <button
                    onClick={handleGoBack}
                    className="flex gap-4 items-center cursor-pointer w-[100px]"
                >
                    <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M19 11.4997H7.82999L12.71 6.61967C13.1 6.22967 13.1 5.58967 12.71 5.19967C12.6175 5.10697 12.5076 5.03342 12.3866 4.98324C12.2656 4.93306 12.136 4.90723 12.005 4.90723C11.874 4.90723 11.7443 4.93306 11.6234 4.98324C11.5024 5.03342 11.3925 5.10697 11.3 5.19967L4.70999 11.7897C4.61728 11.8822 4.54373 11.9921 4.49355 12.113C4.44337 12.234 4.41754 12.3637 4.41754 12.4947C4.41754 12.6256 4.44337 12.7553 4.49355 12.8763C4.54373 12.9973 4.61728 13.1072 4.70999 13.1997L11.3 19.7897C11.3926 19.8823 11.5025 19.9557 11.6234 20.0058C11.7444 20.0559 11.8741 20.0817 12.005 20.0817C12.1359 20.0817 12.2656 20.0559 12.3865 20.0058C12.5075 19.9557 12.6174 19.8823 12.71 19.7897C12.8026 19.6971 12.876 19.5872 12.9261 19.4662C12.9762 19.3453 13.002 19.2156 13.002 19.0847C13.002 18.9537 12.9762 18.8241 12.9261 18.7031C12.876 18.5822 12.8026 18.4723 12.71 18.3797L7.82999 13.4997H19C19.55 13.4997 20 13.0497 20 12.4997C20 11.9497 19.55 11.4997 19 11.4997Z"
                            fill="#11485B"
                        />
                    </svg>
                    <p className="text-[#11485B] font-[600]">Back</p>
                </button>
                <img src="../assets/logo3.png" alt="" className="w-[200px]" />
            </div>
            <div className="relative mt-6">
                {/* <img
          src="./assets/logo1.png"
          alt=""
          className="absolute inset-0  object-cover opacity-70  mx-auto my-auto"
        /> */}
                <div className="relative z-10">
                    <div className="bg-[#139EB5] w-full">
                        <div className="bg-white w-fit xl:mx-[120px] mx-3 px-2">
                            <h1 className="text-[#11485B] xl:text-3xl md:text-2xl text-xl text-center font-[700]">
                                {data?.title}
                            </h1>
                        </div>
                    </div>

                    <div className="lg:px-6 xl:px-[120px] px-4 font-normal blog   w-full flex flex-col gap-5 2xl:py-10 xl:py-7 py-5">
                        {mergedSections.map((section, index) => {
                            switch (section?.sectionType) {
                                case "headingListImage":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingListImage(section)}
                                        </React.Fragment>
                                    );

                                // 🧩 Add more section types as needed
                                case "headingMultiParaImage":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingMultiParaImage(section)}
                                        </React.Fragment>
                                    );
                                case "headingListImage":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingListImage(section)}
                                        </React.Fragment>
                                    );

                                // 🧩 Add more section types as needed
                                case "headingMultiHeadingList":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingMultiHeadingList(section)}
                                        </React.Fragment>
                                    );
                                case "headingParaImage":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingParaImage(section)}
                                        </React.Fragment>
                                    );

                                // 🧩 Add more section types as needed
                                case "headingParaList":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingParaList(section)}
                                        </React.Fragment>
                                    );
                                case "headingWithMultiPara":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingWithMultiPara(section)}
                                        </React.Fragment>
                                    );
                                case "headingWithPara":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingWithPara(section)}
                                        </React.Fragment>
                                    );
                                case "headingWithList":
                                    return (
                                        <React.Fragment key={index}>
                                            {headingWithList(section)}
                                        </React.Fragment>
                                    );

                                // 🧱 Default (fallback) case
                                default:
                                    return null;
                            }
                        })}
                    </div>
                    <div className="w-full flex justify-center items-center px-4">
                        <Link to={data?.data?.callToAction?.link}>
                            <button
                                type="button"
                                className=" px-4 py-2 text-lg bg-[#139EB5] text-white rounded-sm hover:-translate-y-1 duration-300 hover:bg-[#11485B] font-semibold"
                            >
                                {data?.data?.callToAction?.btnName}
                            </button>
                        </Link>
                    </div>
                    <div className="p-4 w-full h-[30rem]">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.273213712704!2d-0.21395462303454!3d51.52654850930389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876118dba5b7b0f%3A0xb59bead03ab72fe1!2sAqua%20Medical%20Laboratories%20LTD!5e0!3m2!1sen!2sin!4v1766467823337!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Google Map Location"
                        ></iframe>
                    </div>

                    <div className="bg-[#139EB5] w-full h-[40px] mt-5"></div>
                </div>
            </div>
        </div>
    );
};

export default AnotherBlogDetails;

{
    /* headingWithMultiPara */
}
const headingWithMultiPara = (item) => {
    return (
        <div  className="w-full flex flex-col xl:gap-2 gap-1">
            <h2 className="text-[#a3d284]  md:text-2xl text-xl font-bold tracking-wide">
                {item?.heading}
            </h2>
            <div className="w-full  flex flex-col gap-1 text-gray-600  font-medium xl:text-xl md:text-lg text-base text-justify ">
                {item?.description?.map((d) => (
                    <p>{d?.value}</p>
                ))}
            </div>
        </div>
    );
};
{
    /* headingMultiParaImage */
}
const headingMultiParaImage = (item) => {
    return (
        <div
            className={`w-full  flex lg:flex-row flex-col border-[#a3d284] px-4 gap-5 `}
        >
            <div className="w-full flex flex-1 flex-col xl:gap-2 gap-1 ">
                <h2 className="text-[#a3d284]  xl:text-3xl md:text-2xl text-xl  font-bold tracking-wide">
                    {item?.heading}
                </h2>
                <div className="w-full  flex flex-col gap-4 text-gray-600  font-medium xl:text-xl md:text-lg text-base  text-justify">
                    {item?.description?.map((d, index) => (
                        <p key={index}>{d?.value}</p>
                    ))}
                </div>
            </div>
            <div className="w-full flex-1 ">
                <img
                    src={imageBaseURL+item?.image}
                    alt={item?.alt}
                    className="w-full max-h-[30rem]  object-cover rounded-xl"
                />
            </div>
        </div>
    );
};
{
    /* headingListImage */
}

const headingListImage = (item) => {
    return (
        <div className={`w-full  flex lg:flex-row flex-col border-[#a3d284] px-4 gap-5 `}>
            <div className="w-full flex flex-1 flex-col gap-2 ">
                <h2 className="text-[#a3d284]  xl:text-3xl md:text-2xl text-xl font-bold tracking-wide">
                    {item?.heading}
                </h2>
                <ul className="w-full  flex flex-col text-gray-600  font-medium xl:text-xl md:text-lg text-base  ">
                    {item?.list?.map((d, index) => (
                        <li key={index}>{d?.value}</li>
                    ))}
                </ul>
            </div>
            <div className="w-full flex-1 ">
                <img
                    src={imageBaseURL+item?.image}
                    alt={item?.alt}
                    className="w-full max-h-[30rem] object-cover rounded-xl"
                />
            </div>
        </div>
    );
};
{
    /* headingMultiHeadingList */
}
const headingMultiHeadingList = (item) => {
    return (
        <div className={`w-full  flex  border-[#a3d284] px-4  gap-5`}>
            <div className="w-full flex  flex-col gap-5 ">
                <h2 className="text-[#a3d284]  xl:text-3xl md:text-2xl text-xl font-bold tracking-wide">
                    {item?.heading}
                </h2>
                <div className="w-full  flex flex-col  gap-5">
                    {item?.headingList?.map((h, index) => (
                        <div key={index} className="">
                            <h3 className="text-[#a3d284]  xl:text-2xl text-xl font-bold tracking-wide">
                                {h?.heading}
                            </h3>
                            <ul className="w-full  flex flex-col text-gray-600  font-medium xl:text-xl md:text-lg text-base  ">
                                {h?.list?.map((d, a) => (
                                    <li key={a}>{d?.value}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
{
    /* headingParaImage */
}
const headingParaImage = (item) => {
    return (
        <div className={`w-full  flex lg:flex-row flex-col border-[#a3d284] px-4 gap-5 `}>
            <div className="w-full flex flex-1 flex-col gap-2 ">
                <h2 className="text-[#a3d284]  xl:text-3xl md:text-2xl text-xl font-bold tracking-wide">
                    {item?.heading}
                </h2>
                <p className="w-full text-gray-600  font-medium xl:text-xl md:text-lg text-base  text-justify">
                    {item?.description}
                </p>
            </div>
            <div className="w-full flex-1 ">
                <img
                    src={imageBaseURL+item?.image}
                    alt={item?.alt}
                    className="w-full max-h-[30rem]  object-cover rounded-xl"
                />
            </div>
        </div>
    );
};
{
    /* headingParaList */
}
const headingParaList = (item) => {
    return (
        <div className="w-full flex flex-col gap-2">
            <h2 className="text-[#a3d284]  xl:text-2xl md:text-xl text-lg font-bold tracking-wide">
                {item?.heading}
            </h2>
            <p className="w-full text-gray-600  font-medium xl:text-xl md:text-lg text-base  text-justify">
                {item?.description}
            </p>
            <ul className="w-full  flex flex-col text-gray-600  font-medium xl:text-xl md:text-lg text-base  ">
                {item?.list?.map((d, index) => (
                    <li key={index}>{d?.value}</li>
                ))}
            </ul>
        </div>
    );
};
{
    /* headingWithPara */
}
const headingWithPara = (item) => {
    return (
        <div className="w-full flex flex-col gap-2">
            <h2 className="text-[#a3d284]  xl:text-2xl md:text-xl text-lg font-bold tracking-wide">
                {item?.heading}
            </h2>
            <p className="w-full text-gray-600  font-medium xl:text-xl md:text-lg text-base text-justify">
                {item?.description}
            </p>
        </div>
    );
};
{
    /* headingWithList */
}
const headingWithList = (item) => {
    return (
        <div className="w-full flex flex-col gap-2">
            <h2 className="text-[#a3d284]  xl:text-2xl md:text-xl text-lg font-bold tracking-wide">
                {item?.heading}
            </h2>
            <ul className="w-full  flex flex-col text-gray-600  font-medium xl:text-xl md:text-lg text-base  ">
                {item?.list?.map((d, index) => (
                    <li key={index}>{d?.value}</li>
                ))}
            </ul>
        </div>
    );
};
